import { jsx } from "react/jsx-runtime";
import { Switch as MuiSwitch } from "@mui/material";
function Switch(props) {
  const { label, value, setField, switchProps } = props;
  return /* @__PURE__ */ jsx(
    MuiSwitch,
    {
      ...switchProps,
      checked: value,
      "data-testid": "TidalControlsSwitch",
      onChange: (_, checked) => {
        setField(label, checked);
      },
      value
    }
  );
}
export {
  Switch
};
//# sourceMappingURL=Switch.js.map
